export const screenerCopyDa = {
    start: "Start",
    starting: "Starter...",
    checking: "Dine svar bliver tjekket...",
    notFoundTitle: "Dette link virker ikke",
    notFoundBody: "Spørgeskemaet er muligvis lukket. Kontakt det team, der gav dig dette link.",
    eligibleTitle: "Du kan deltage",
    eligibleBody: "Opret din konto for at komme i gang.",
    ineligibleTitle: "Dette passer ikke til dig",
    ineligibleBody:
        "Tak for dine svar. Ud fra dine svar opfylder du ikke kriterierne. Hvis du har spørgsmål, så kontakt det team, der gav dig dette link.",
    continueToSignUp: "Fortsæt til tilmelding",
    scanOnPhone: "Eller scan denne kode med din telefons kamera for at tilmelde dig på telefonen.",
    startAgain: "Start forfra",
};
